import { createSliceContext } from "./CreateSliceContext";

// props for the Search slice context
interface SearchSliceProps {
  location: Location;
  isHotelPage: boolean;
  showEditSearch: boolean;
  onShowEditSearch: (value: boolean) => void;
}

const defaultSearchSliceValues: SearchSliceProps = {
  location: { pathname: "/" } as Location,
  isHotelPage: false,
  showEditSearch: false,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onShowEditSearch: () => {},
};

export const {
  Provider: SearchSliceProvider,
  useContext: useSearchSliceContext,
} = createSliceContext<SearchSliceProps>("Search", defaultSearchSliceValues);
